export default function LogoMark({ className = "h-9 w-9" }) {
  return (
    <svg
      viewBox="0 0 64 64"
      className={className}
      fill="none"
      aria-hidden="true"
    >
      <g stroke="currentColor" strokeWidth="3" strokeLinecap="round">
        <path d="M26.5 16v-2.5c0-3.6 2.5-6 5.5-6s5.5 2.4 5.5 6V16" />
        <circle cx="32" cy="33" r="14.5" />
        <path d="M32 47.5v3c0 5.5-8 5.5-8 1.2" />
      </g>
      <path
        d="M32 22.5l2.4 10.5-2.4 10.5-2.4-10.5z"
        fill="currentColor"
        stroke="none"
      />
      <path
        d="M18 33c4.7-2.2 9.3-2.2 14 0s9.3 2.2 14 0"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
      />
      <circle cx="32" cy="33" r="2.8" fill="currentColor" stroke="none" />
    </svg>
  );
}
